import { TypeAlert } from '../../interfaces/TypeAlert/typeAlert'
import {
  GET_TYPE_ALERT,
  GET_TYPE_ALERT_EXITO
} from '../types/typeAlertActionsTypes'

export type TypeAlertAction = TypesAlertAction | TypesAlertActionAsync

// Esto va a REDUX
export interface TypesAlertAction {
  type: typeof GET_TYPE_ALERT_EXITO
  typesAlert: TypeAlert[] | undefined
  error: string | undefined
}

export const getTypesAlertAction = (
  typesAlert?: TypeAlert[],
  error?: string
): TypesAlertAction => ({
  type: GET_TYPE_ALERT_EXITO,
  typesAlert,
  error
})

// Esto va a SAGA
export interface TypesAlertActionAsync {
  type: typeof GET_TYPE_ALERT
}

export const getTypesAlertActionAsync = (): TypesAlertActionAsync => ({
  type: GET_TYPE_ALERT
})
